import { noop } from '../general';

export const nonAwaitedPromiseHandler = <TResponse>(method: () => Promise<TResponse>): void => {
  method()
    .then(() => noop)
    .catch(() => noop);
};

export const nonAwaitedPromiseHandlerParametrized = <TResponse, TParam>(
  method: (param: TParam) => Promise<TResponse>,
  param: TParam,
): void => {
  method(param)
    .then(() => noop)
    .catch(() => noop);
};
